import React from 'react';
import { useFdCan } from '../hooks/useFdCan';
import type { FdSection } from '../utils/frontDeskMatrix';

/**
 * Wraps a form (or a drawer body and its footer) so the tenant Front Desk, who only views `section`
 * (specs/front-desk-tenant-permisos.md), can read it but not change it: every input, select, textarea and
 * button inside is disabled by the browser. For everyone else it renders its children unchanged. The server
 * refuses the writes anyway; this keeps the UI from offering them.
 */
export const ReadOnlyFence: React.FC<{ section: FdSection; children: React.ReactNode }> = ({ section, children }) => {
  const canEdit = useFdCan(section, 'edit');
  if (canEdit) return <>{children}</>;
  return (
    <fieldset disabled data-testid="read-only-fence" style={{ border: 0, margin: 0, padding: 0, minWidth: 0, display: 'contents' }}>
      {children}
    </fieldset>
  );
};
